import { render, staticRenderFns } from "./Summary.vue?vue&type=template&id=27db40d0&scoped=true&lang=pug"
import script from "./Summary.js?vue&type=script&lang=js&external"
export * from "./Summary.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27db40d0",
  null
  
)

export default component.exports